import { MessageCircle } from "lucide-react";

export default function WhatsAppButton() {
  const phone = "1234567890";
  const message = encodeURIComponent("Hi, I need help with my onward flight reservation");
  const url = `https://wa.me/${phone}?text=${message}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-20 right-5 z-40 group"
      data-testid="whatsapp-button"
    >
      <div className="relative">
        {/* Tooltip */}
        <span className="absolute right-14 top-1/2 -translate-y-1/2 bg-[#1f2937] text-white text-xs font-medium px-3 py-1.5 rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
          Need help? Chat with us
        </span>
        {/* Button */}
        <div className="w-12 h-12 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-110 transition-all duration-300">
          <MessageCircle className="w-6 h-6 text-white" />
        </div>
      </div>
    </a>
  );
}
